import { render, staticRenderFns } from "./LikertAssertionForm.vue?vue&type=template&id=7cabdd10"
import script from "./LikertAssertionForm.vue?vue&type=script&lang=js"
export * from "./LikertAssertionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports